<nb-card
  style="
    max-height: 70vh;
    min-width: 200px;
    overflow-y: auto !important;
    margin: 10px;
    margin-top: 0;
    border: none;
  "
  size="large"
  *ngIf="isAllowDesign"
>
  <nb-card-header
    style="
      padding: 5px 5px;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: space-between;
    "
  >
    <span>List Variable</span>
    <button
      class="alert-circle-outline"
      type="button"
      ghost
      nbTooltip="You can store key-value pairs as variables. And you can using variable in your flow. Example: &#123;name_variable&#125;."
      nbTooltipPlacement="bottom"
      nbTooltipStatus="basic"
      nbTooltipTrigger="hover"
      size="small"
      nbButton
      (click)="routerVariable()"
    >
      <nb-icon icon="question-mark-circle-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body class="mb-2 mt-2" style="padding: 0 !important">
    <input
      type="text"
      nbInput
      [(ngModel)]="searchText"
      fullWidth
      (keyup)="filterVariable()"
      placeholder="Search Variable"
      fieldSize="small"
      class="mb-2"
    />
    
    <nb-accordion multi>
      <nb-accordion-item #systemAccordion>
        <nb-accordion-item-header class="p-2 small-font align-between ivr-variable-chevron" (click)="selectTab('system')">
          <div class="d-flex align-items-center justify-content-between w-100">
            <!-- Left side -->
            <div class="d-flex align-items-center">
              <span>System</span>
              <nb-icon
                class="hint-icon"
                style="color: #929bb3; width: 15px; margin-bottom: 2px"
                nbTooltip="System variables are predefined and cannot be modified. These variables contain essential system information and are automatically managed by the system."
                nbTooltipPlacement="end"
                nbTooltipStatus="basic"
                nbTooltipTrigger="hover"
                icon="question-mark-circle-outline"
              >
              </nb-icon>
            </div>
            <!-- Right side -->
            <div class="d-flex align-items-center">
              <nb-icon 
                [icon]="expandedSections.system ? 'chevron-up-outline' : 'chevron-down-outline'"
                class="collapse-icon"
                [class.expanded]="expandedSections.system"
                (click)="toggleAccordion('system', $event)">
              </nb-icon>
            </div>
          </div>
        </nb-accordion-item-header>
        <nb-accordion-item-body class="ivr-varriable-custom">
          <nb-list *ngFor="let item of variableList">
            <nb-list-item
              *ngIf="item.default == 1"
              (click)="clickedRow(item)"
              [class.active]="item == selectedItem"
              (dblclick)="editAttribute(item)"
              (dragstart)="dragStart($event)"
              draggable="false"
              class="list-item"
            >
              <ng-container class="p-0">
                <span>{{ item.value }}</span>
              </ng-container>
            </nb-list-item>
          </nb-list>
        </nb-accordion-item-body>
      </nb-accordion-item>
      <nb-accordion-item #envAccordion>
        <nb-accordion-item-header class="p-2 small-font align-between ivr-variable-chevron" (click)="selectTab('env')">
          <div class="d-flex align-items-center justify-content-between w-100">
            <!-- Left side: Label and tooltip -->
            <div class="d-flex align-items-center">
              <span>Environment</span>
              <nb-icon
                class="hint-icon"
                style="color: #929bb3; width: 15px; margin-bottom: 2px"
                nbTooltip="Environment variables can be used across flows and subflows."
                nbTooltipPlacement="end"
                nbTooltipStatus="basic"
                nbTooltipTrigger="hover"
                icon="question-mark-circle-outline"
              >
              </nb-icon>
            </div>
            
            <!-- Right side: Action buttons -->
            <div class="d-flex align-items-center">
              <button nbButton size="tiny" (click)="addSystemAttribute();$event.stopPropagation()" class="me-2">
                <nb-icon icon="plus"></nb-icon>
              </button>
              <nb-icon 
                [icon]="expandedSections.env ? 'chevron-up-outline' : 'chevron-down-outline'"
                class="collapse-icon"
                [class.expanded]="expandedSections.env"
                (click)="toggleAccordion('env', $event)">
              </nb-icon>
            </div>
          </div>
        </nb-accordion-item-header>
        <nb-accordion-item-body class="ivr-varriable-custom">
          <nb-list *ngFor="let item of variableList">
            <nb-list-item
              *ngIf="item.default == 2"
              (dragstart)="dragStart($event)"
              draggable="false"
              class="list-item"
            >
              <ng-container class="p-0">
                <div class="align-between">
                  <span>{{ item.value }}</span>
                  <div>
                    <nb-icon 
                      icon="edit-outline" 
                      status="basic" 
                      class="change-cursor me-1"
                      (click)="editAttribute(item)"
                    ></nb-icon>
                    <nb-icon 
                      icon="minus-circle-outline" 
                      status="basic" 
                      class="change-cursor"
                      (click)="deleteAttribute(item)"
                    ></nb-icon>
                  </div>
                </div>
              </ng-container>
            </nb-list-item>
          </nb-list>
        </nb-accordion-item-body>
      </nb-accordion-item>
      <nb-accordion-item #userAccordion>
        <nb-accordion-item-header class="p-2 small-font align-between ivr-variable-chevron" (click)="selectTab('user')">
          <div class="d-flex align-items-center justify-content-between w-100">
            <!-- Left side -->
            <div class="d-flex align-items-center">
              <span>User</span>
              <nb-icon
                class="hint-icon"
                style="color: #929bb3; width: 15px; margin-bottom: 2px"
                nbTooltip="User variables are specific to the current flow and cannot be used in subflows."
                nbTooltipPlacement="end"
                nbTooltipStatus="basic"
                nbTooltipTrigger="hover"
                icon="question-mark-circle-outline"
              >
              </nb-icon>
            </div>
            <!-- Right side -->
            <div class="d-flex align-items-center">
              <button nbButton size="tiny" (click)="addAttribute();$event.stopPropagation()" class="me-2">
                <nb-icon icon="plus"></nb-icon>
              </button>
              <nb-icon 
                [icon]="expandedSections.user ? 'chevron-up-outline' : 'chevron-down-outline'"
                class="collapse-icon"
                [class.expanded]="expandedSections.user"
                (click)="toggleAccordion('user', $event)">
              </nb-icon>
            </div>
          </div>
        </nb-accordion-item-header>
        <nb-accordion-item-body class="ivr-varriable-custom">
          <nb-list *ngFor="let item of variableList">
            <nb-list-item
              *ngIf="item.default == 0"
              (dragstart)="dragStart($event)"
              draggable="false"
              class="list-item"
            >
              <ng-container class="p-0">
                <div class="align-between">
                  <span>{{ item.value }}</span>
                  <div>
                    <nb-icon 
                      icon="edit-outline" 
                      status="basic" 
                      class="change-cursor me-1"
                      (click)="editAttribute(item)"
                    ></nb-icon>
                    <nb-icon 
                      icon="minus-circle-outline" 
                      status="basic" 
                      class="change-cursor"
                      (click)="deleteAttribute(item)"
                    ></nb-icon>
                  </div>
                </div>
              </ng-container>
            </nb-list-item>
          </nb-list>
        </nb-accordion-item-body>
      </nb-accordion-item>
    </nb-accordion>
  </nb-card-body>
</nb-card>
